import { NamedEntity } from '@shared';
import { TierDocument } from './tier-document.model';

export class Tier extends NamedEntity {
  isLocked?: boolean;
  kingRestaurantId?: string;
  kingRestaurantName?: string;
  kingRestaurantLastRbiPriceUpdate?: Date | null;
  isSynchedToKing?: boolean;
  priceTierDocument?: TierDocument;

  constructor(tier: Partial<Tier>) {
    super(tier.id ?? '', tier.name ?? '');
    this.isLocked = tier.isLocked;
    this.kingRestaurantId = tier.kingRestaurantId;
    this.kingRestaurantName = tier.kingRestaurantName;
    this.isSynchedToKing = tier.isSynchedToKing;
    this.priceTierDocument = tier.priceTierDocument;
    this.kingRestaurantLastRbiPriceUpdate = tier.kingRestaurantLastRbiPriceUpdate;
  }
}
